'use strict';

const clientSideValidation = require('../components/clientSideValidation');
const { get } = require('lodash');

/**
 * Initializes all event handlers and AJAX interactions
 * related to the boutique popup functionality.
 */
const initBoutique = function () {
    const $document = $(document);
    const $body = $('body');
    let updateBotique = true;

    // Handles click on boutique trigger button
    $document.on('click', '.product-boutique-slider, .check-boutique-availability', function () {
        const pid = $('.product-detail').first().data('pid');
        if (pid) {
            const $this = $(this);
            if (updateBotique) {
                // Load boutique overlay only once unless product attribute changes
                $.spinner().start();
                $.ajax({
                    url: $this.data('action'),
                    type: 'get',
                    data: { pid: pid },
                    success: function (result) {
                        // Show or hide error text based on result
                        const $errorEle = $this.closest('.product-boutique-slider-wrapper').find('.error-text');
                        $errorEle.toggleClass('d-none', !result.error);
                        if (!result.error) {
                            // Remove any existing slider before appending new one
                            $('#boutique-overlay-slider').remove();
                            // Append rendered HTML from server
                            $body.append($.parseHTML(result.renderedTemplate));
                            // Trigger custom select UI init
                            $document.trigger('customSelectInit');
                            // Open the boutique slider
                            $document.trigger('openSlider', {
                                target: '#boutique-overlay-slider',
                            });
                            // Count how many stores were returned
                            const storeCount = $('.boutique-store-list .boutique-store-item').length;
                            // Update UI with selected country and store count
                            $('.boutique-selected-country').text($('.boutique-country select option:selected').text().trim());
                            $('.boutique-selected-count').text(storeCount);
                            $('.boutique-label-store').toggleClass('d-none', storeCount > 1);
                            $('.boutique-label-stores').toggleClass('d-none', storeCount === 1);

                            // Show or hide "no result" message
                            $('.boutique-store-noresult').toggleClass('d-none', storeCount > 0);
                            $('.boutique-store-result').toggleClass('d-none', storeCount === 0);
                            // Prevent reloading overlay until variation changes
                            updateBotique = false;
                        }
                        $.spinner().stop();
                    },
                });
            } else {
                // If already loaded, just reopen the existing slider
                $document.trigger('openSlider', {
                    target: '#boutique-overlay-slider',
                });
            }
        }
    });

    // Reset the boutique popup to update when product attributes (like size) are changed
    $body.on('product:afterAttributeSelect', function () {
        updateBotique = true;
    });

    $document.on('boutiqueUpdateStores', function (e, data) {
        const $storeWrapper = $('.boutique-slider-body');
        $storeWrapper.spinner().start();
        $.ajax({
            url: data.url,
            type: 'get',
            data: {
                pid: data.pid,
                country: data.country,
                updateOnSelectCountry: data.updateOnSelectCountry,
            },
            success: function (result) {
                // Update store list section with server-rendered HTML
                $('.boutique-store-info').empty().html(result.storeHtml);
                const storeCount = $('.boutique-store-info .boutique-store-item').length;
                // Update display values
                $('.boutique-selected-country').text($('.boutique-country select option:selected').text().trim());
                $('.boutique-selected-count').text(storeCount);
                $('.boutique-label-store').toggleClass('d-none', storeCount > 1);
                $('.boutique-label-stores').toggleClass('d-none', storeCount === 1);
                $('.boutique-store-noresult').toggleClass('d-none', storeCount > 0);
                $('.boutique-store-result').toggleClass('d-none', storeCount === 0);
                $storeWrapper.spinner().stop();
                $('body').trigger('gtm:add:event', result);
            },
        });
    });

    // Handle country dropdown change inside boutique popup
    $document.on('change', '.boutique-country select', function () {
        const $this = $(this);
        const $attrEle = $('.custom-nonswatch-wrapper');
        let validProduct = true;
        if ($attrEle.length) {
            $attrEle.each(function () {
                const $thisInnter = $(this);
                const selectEleVal = $thisInnter.find('select').val();
                if (!selectEleVal) {
                    $thisInnter.find('invalid-feedback').addClass('d-block');
                    validProduct = false;
                }
            });
        }
        if (validProduct) {
            const $popupBody = $this.closest('.boutique-slider-body');
            const $selectVal = $this.val();
            const pid = $popupBody.find('.custom-product-card').data('pid');
            $document.trigger('boutiqueUpdateStores', {
                url: $this.data('action'),
                pid: pid,
                country: $selectVal,
                updateOnSelectCountry: true,
            });
        }
    });

    // Handle reservation form submission
    $document.on('click', '.boutique-reserve-submit', function (e) {
        e.preventDefault();
        const $this = $(this);
        const $thisForm = $this.closest('form');
        const $thisWrapper = $this.closest('.slider-wrapper');

        // Validate form using imported client-side validation
        const validForm = clientSideValidation.functions.validateForm($thisForm.get(0));

        // Get selected store address info from the closest DOM block
        const storeAddress = $thisWrapper.find('.store-address-info').first().data();

        if (validForm) {
            // Serialize form fields to object
            const formArray = $thisForm.serializeArray();
            const formDataObj = {};
            formArray.forEach(function (item) {
                formDataObj[item.name] = item.value;
            });

            // Combine form fields with selected store address data
            const mergedData = Object.assign({}, formDataObj, storeAddress);

            $.spinner().start();
            $.ajax({
                url: $thisForm.attr('action'),
                type: 'post',
                data: mergedData,
                success: function (data) {
                    // Show success message after reservation
                    $.spinner().stop();
                    $('.boutique-overlay .slider-wrapper').empty().html(data.storeSuccessHtml);
                    updateBotique = true;
                    $('body').trigger('gtm:add:event', { datalayer: get(data, 'datalayer', []) });
                },
            });
        }
    });

    // Opens the reservation form inside the popup
    $document.on('click', '.boutique-store-reserve', function () {
        const $this = $(this);
        $('.boutique-reserve-address').empty().html($this.closest('.boutique-store-item').find('.boutique-store-address').html());
        $this.closest('.slider-wrapper').addClass('reserve-form-active');
    });

    // Back button to return to store list from reservation form
    $document.on('click', '.boutique-reserve-back', function () {
        $(this).closest('.slider-wrapper').removeClass('reserve-form-active');
    });
};

module.exports = {
    initBoutique: initBoutique,
};
